import { useState, useImperativeHandle, forwardRef, useRef } from "react";
import CSVReader from "react-csv-reader";
import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Link from "@mui/material/Link";
import { BiCloudUpload } from "react-icons/bi";
import SimpleActionDialog from "../SimpleActionDialog/SimpleActionDialog";
import { MdWarning } from "react-icons/md";
import { theme } from "../../theme";
import FileSaver from "file-saver";
import NotificationMessage from "../NotificationMessage/NotificationMessage";
import { dataType } from "../GenericList/GenericList";
import FdTypography from "../UIComponents/Typography/FdTypography";
import {csvUploader as classes} from "./styles";
// CSV file column names (first letter lowercase)
// const CSVAttendeeColumns = [
//   "thirdPartyID",
//   "category",
//   "firstName",
//   "lastName",
//   "email",
//   "company",
//   "jobTitle",
//   "country",
//   "registrationStatus",
//   "checkinDate",
//   "kioskName",
//   "operator",
//   "location",
//   "barcode",
//   "checkinMode",
// ];

// const CSVSessionColumns = [
//   "allowOUT-scanning",
//   "allowforcecheck-in",
//   "capacitylimit",
//   "description",
//   "end",
//   "externalSessionID",
//   "fdEntrymode",
//   "name",
//   "sessionLocation",
//   "speakers",
//   "start",
// ];

// const CSVReservationColumns = ["attendeeThirdPartyID", "amount", "message"];

export interface IProps {
  onFileUpload: (data: any, fileInfo: any, file: File) => void;
  type: dataType; // the expected type of csv file
  hideButton?: boolean;
}

const CSVUploader = ({ onFileUpload, hideButton, type }: IProps, ref: any) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [inputKey, setInputKey] = useState(""); // state used to force the CSV Reader element rerender
  const notificationRef = useRef<any>();

  const papaparseOptions = {
    header: true,
    // dynamicTyping: true,
    skipEmptyLines: true,
    // transformHeader: (header: any) => {
    //   try {
    //     return header[0].toUpperCase() + header.replace(/\s/g, "").slice(1);
    //   } catch (error: any) {
    //     console.log(error);
    //     // handleFileError();
    //   }
    // },
  };

  useImperativeHandle(
    ref,
    () => ({
      showWarning() {
        showWarningDialog();
      },
    }),
    []
  );

  // check the file columns and pass the file and data to parent component
  const handleFileLoad = (data: any, fileInfo: any) => {
    const input = document.getElementById("csv-upload-input") as any;
    onFileUpload(data, fileInfo, input.files[0]);

    // reload the CSV reader element
    forceElementReload();
  };

  // const handleFileError = () => {
  //   showWarningDialog();
  //   notificationRef.current?.show(
  //     "There is a problem with your uploaded CSV file",
  //     notificationType.Error
  //   );

  //   // reload the CSV reader element
  //   forceElementReload();
  // };

  // // check if the first data element has all the keys of the CSV Columns
  // const isValidData = (data: any[]) => {
  //   try {
  //     const columnsTemplate =
  //       type === dataType.SESSIONS
  //         ? CSVSessionColumns
  //         : type === dataType.RESERVATIONS
  //         ? CSVReservationColumns
  //         : CSVAttendeeColumns;
  //     return columnsTemplate.every(
  //       (column) =>
  //         typeof data[0][column] !== undefined &&
  //         typeof data[0][column] !== "undefined"
  //     );
  //   } catch (error: any) {}
  // };

  // handle the Upload button click -> open the upload window and close the dialog
  const onDialogActionClick = () => {
    const uploadButton = document.getElementById("csv-upload-input");
    if (uploadButton) {
      uploadButton.click();
    }
    setOpenDialog(false);
  };

  const showWarningDialog = () => {
    setOpenDialog(true);
  };

  const handleSaveTemplate = (e: any) => {
    e.preventDefault();
    let fileName;
    switch (type) {
      case dataType.ATTENDEES:
        fileName = "attendees";
        break;
      case dataType.SESSIONS:
        fileName = "sessions";
        break;
      case dataType.RESERVATIONS:
        fileName = "reservations";
        break;
      default:
        fileName = "";
    }

    FileSaver.saveAs(
      process.env.PUBLIC_URL + `/resources/${fileName}_template.csv`,
      `My${fileName.charAt(0).toUpperCase() + fileName.slice(1)}.csv`
    );
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  // we need to force the csv reader element reload, otherwise it will not open two times consequently
  const forceElementReload = () => {
    const randomString = Math.random().toString(36);
    setInputKey(randomString);
  };

  return (
    <>
      <Grid
        key={"csv_upload"}
        item
        // xs={3}
        // need to hide this button element in some use cases
        style={hideButton === true ? { display: "none" } : {}}
      >
        <Box
          sx={classes.customButton}
          onClick={() => {
            showWarningDialog();
          }}
        >
          <Box sx={classes.customButtonIcon} mb={0}>
            <BiCloudUpload />
          </Box>
          <FdTypography sx={classes.customButtonLabel} label="CSV Upload" />
          <Tooltip title={"test"}>
            <span key={inputKey}>
              <CSVReader
                // strict={true}
                inputId="csv-upload-input"
                cssClass="csvUploader"
                cssInputClass="csvUploaderInput"
                parserOptions={papaparseOptions}
                onFileLoaded={handleFileLoad}
                // onError={() => {
                //   handleFileError();
                // }}
              />
            </span>
          </Tooltip>
        </Box>
      </Grid>

      <SimpleActionDialog
        open={openDialog}
        onClose={handleCloseDialog}
        title="CSV Upload Warning!"
        content={
          <>
            Here’s an example you can base yourself on:{" "}
            <Link href="#" underline="always" onClick={handleSaveTemplate}>
              download
            </Link>
          </>
        }
        confirmLabel="Upload"
        icon={<MdWarning size="45" color={theme.palette.primary.main} />}
        onConfirm={onDialogActionClick}
        cancelLabel="Cancel"
        onCancel={handleCloseDialog}
        disablePortal={true}
      />

      <NotificationMessage ref={notificationRef} />
    </>
  );
};

export default forwardRef(CSVUploader);
